import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function MapuTofu() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Mapu Tofu</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>8 ounces shiitake
        mushrooms <br></br>2 cups water<br></br>
        15 ounce block of soft tofu (not silken)<br></br>
        Salt<br></br>3 tbsp olive oil<br></br>3 small dried hot red peppers
        <br></br>1 tbsp femented black beans<br></br>1 tbsp fermented spicy
        broad bean paste (doubanjiang)<br></br>2 tsp minced garlice<br></br>1
        tbsp grated ginger<br></br>2 tsp soy sauce<br></br>1 tsp taoasted sesame
        oil <br></br>1 tsp finel ground Sichuan pepper <br></br>1 tbsp
        (corn/potato) starch, dissolved in 3 tbsp cold water<br></br>
        1/2 cup slivered scallions (spring onions)<br></br>
      </Typography>

      <Typography>
        Remove stems from mushrooms.<br></br>
        Make a light mushroom broth by simmering stems in 2 cups water for 15
        minutes, then strain and reserve broth (discard stems).<br></br>
        Dice mushroom caps and set aside.<br></br>
        <br></br>
        Cut tofu into 1-inch cubes.<br></br>
        Cover with boiling salted water, let steep for 15 minutes, then drain.
        <br></br>
        <br></br>
        Put oil in a wok or wide skillet over medium heat.<br></br>
        Add red peppers, balck beans, and bea paste and cook, stirring until
        fragrant, about 1 minute.<br></br>
        Add garlic and ginger and let sizzle, then add mushrooms, soy sauce,
        sasame oil and Sichuan pepper.<br></br>
        Add 1.5 cups mushroom broth and cook mixture gently for 2 minutes.
        <br></br>
        <br></br>
        Carefully add tofu cubes.<br></br>
        Shake pan to distribute sauce, using a wooden spoon to help.<br></br>
        Try to avoid smashing tofu.<br></br>
        Drizzle in cornstarch mixture, gently swirling pan to incorporate (sauce
        will thicken) and simmer tofu in sauce for 2 minutes more.<br></br>
        Thin with a little mushroom broth if necessary.<br></br>
        Transfer to a low bowl or platter.<br></br>
        Sprinkle with scallions.<br></br>
      </Typography>
    </Card>
  );
}
